module.exports = __webpack_public_path__ + "static/media/kazuko.c01b4307.png";